import { AddressDTO } from "common/dto/Address";
import { api } from "./base-config";

export const findAddressByPatientId = (
  patientId: number
): Promise<AddressDTO[]> => {
  return api
    .get(`/resources/secured/rs/patients/${patientId}/addresses/all`)
    .then(response => response.data);
};
